import {
  IGetCustomPlugInInterface,
  IPostCustomPlugInInterface,
  IPutCustomPlugInInterface,
} from "../interfaces/customPlugIn.interface";
import * as api from "./middleware/api.middleware";
import { requireActiveEnvironmentId } from "./environment.store";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "custom_plugins";
const customPluginApiBaseUrl = process.env.REACT_APP_API_URL ?? "";

const customPluginApiUrl = (path: string) =>
  `${customPluginApiBaseUrl}${path}`;

const customPluginRequestOptions = {
  options: { isUrlExclusive: true },
};

const getCustomerId = () => {
  return localStorage.getItem("customer_id");
};

const getEnvironmentId = () => requireActiveEnvironmentId();

const getAccessToken = () => getAuthHeader();

export function getCustomPlugInDetails() {
  const getResponse = api.get<IGetCustomPlugInInterface[]>(
    customPluginApiUrl(
      `customers/${getCustomerId()}/environments/${getEnvironmentId()}/${serviceUrl}`
    ),
    getAccessToken(),
    customPluginRequestOptions
  );
  return getResponse;
}

export function getCustomPlugInType() {
  const getResponse = api.get<any>(
    customPluginApiUrl("plugin_types"),
    getAccessToken(),
    customPluginRequestOptions
  );
  return getResponse;
}

export function postCustomPlugInDetails(data: any) {
  const getResponse = api.post<IPostCustomPlugInInterface>(
    customPluginApiUrl(
      `customers/${getCustomerId()}/environments/${getEnvironmentId()}/${serviceUrl}`
    ),
    data,
    getAccessToken(),
    customPluginRequestOptions
  );
  return getResponse;
}

export function putCustomPlugInDetails(data: any, id: number) {
  const getResponse = api.put<IPutCustomPlugInInterface>(
    customPluginApiUrl(
      `customers/${getCustomerId()}/environments/${getEnvironmentId()}/${serviceUrl}/${id}`
    ),
    data,
    getAccessToken(),
    customPluginRequestOptions
  );
  return getResponse;
}

export function deleteCustomPlugInDetails(id: number) {
  const getResponse = api.del<any>(
    customPluginApiUrl(
      `customers/${getCustomerId()}/environments/${getEnvironmentId()}/${serviceUrl}/${id}`
    ),
    null,
    getAccessToken(),
    customPluginRequestOptions
  );
  return getResponse;
}
